import { Container } from "react-bootstrap";
import '../../styles/IncidentControl.Component.css';
import IncidentsTable from "./fragments/Table";
import { useEffect, useState } from "react";
import { indexIncident } from "../../api/Incidents/Incidents";
import { useDispatch, useStore } from "react-redux";
import { useTranslation } from "react-i18next";
import { SET_ACTIVE_TAB } from "../../redux/actions/main";

const IncidentControl = () => {
    const store = useStore();
    const { token, fibra } = store.getState().login;
    const headers = { Authorization: `Bearer ${token}` };
    // Paginación
    const [totalItems, setTotalItems] = useState(0);        // Cantidad de registros de la consulta
    const [page, setPage] = useState(1);                    // Página actual que se está consultando
    const [pageSize, setPageSize] = useState(10);           // Cantidad de registros por página
    const [loading, setLoading] = useState(true);
    const [incidents, setIncidents] = useState([]);
    const [status, setStatus] = useState(null);
    const [incident_type_id, setIncidentTypeID] = useState(null);

    const [t] = useTranslation('global');
    const prefix = 'incidents.data';
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: SET_ACTIVE_TAB, tab: '/incidents-control' });
    }, []);

    useEffect(() => {
        getIncidents();
    }, [page, pageSize, status, incident_type_id]);

    const getIncidents = async () => {
        setLoading(true);
        let response = await indexIncident({ headers, page, pageSize, fibra_id: fibra.id, status, incident_type_id });
        // console.log("response incidents: ", response);
        setIncidents(response.data);
        setTotalItems(response.totalItems);
        setLoading(false);
    }
    // Evento lanzado al cambiar de página
    const changePage = (page, pageSize) => {
        setPage(page);
        setPageSize(pageSize);
    }

    const changeStatus = (value) => {
        setStatus(value);
        setPage(1);
    }
    const changeIncidentType = (value) => {
        setIncidentTypeID(value);
        setPage(1);
    }

    return (
        <Container id='incidents-control-component' fluid>
            <IncidentsTable
                is_admin
                theaders={[
                    '#',
                    t(`${prefix}.code`),
                    t(`${prefix}.user`),
                    t(`${prefix}.type`),
                    t(`${prefix}.flat`),
                    t(`${prefix}.sector`),
                    t(`${prefix}.local`),
                    t(`${prefix}.status`),
                    t(`${prefix}.actions`)
                ]}
                tkeys={['id', 'code', 'user', 'incident_type', 'flat', 'sector', 'local', 'status']}
                tbadges={[{ index: 7, color: 'status_color' },{index: 3, color: 'incident_type_color'}]}
                totalItems={totalItems}
                page={page}
                pageSize={pageSize}
                incidents={incidents}
                loading={loading}
                changePage={changePage}
                changeStatus={changeStatus}
                changeIncidentType={changeIncidentType}
                update={getIncidents}
            />
        </Container>
    );
}

export default IncidentControl;